/**
 * NotesDialog - Add/Edit Note Dialog Component
 * Extracted from ClientDetailPage
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FileText, Save, Loader2 } from "lucide-react";

export function NotesDialog({
  open,
  onOpenChange,
  noteType,
  newNote,
  setNewNote,
  newNoteDate,
  setNewNoteDate,
  saving,
  editingNoteId,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-teal-600" />
            {editingNoteId ? "Edit" : "Add"} {noteType === "rn" ? "RN" : "Office"} Note
          </DialogTitle>
          <DialogDescription>
            {noteType === "rn" 
              ? "Clinical notes recorded by nursing staff" 
              : "Administrative notes and general communications"}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Note Date</Label>
            <Input
              type="date"
              value={newNoteDate}
              onChange={(e) => setNewNoteDate(e.target.value)}
              data-testid="note-date-input"
            />
          </div>

          <div className="space-y-2">
            <Label>Note Content *</Label>
            <Textarea
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder={`Enter ${noteType === "rn" ? "clinical" : "office"} note...`}
              rows={6}
              data-testid="note-content-textarea"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={saving || !newNote.trim()} data-testid="save-note-btn">
            {saving ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save className="w-4 h-4 mr-2" />
                {editingNoteId ? "Update Note" : "Save Note"}
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
